module.exports = __webpack_public_path__ + "static/media/banner.78be5f8b.jpg";